import { Component, Inject } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DeviceDetectorService } from "ngx-device-detector";
import { finalize } from "rxjs/operators";
import { QuoteService } from "../../../../quote/services/quote.service";
import { AbstractBiditComponent } from "../../abstract.bidit.component";

export interface TemplateDialogData {
  quote_ID: number;
  quoteTemplate_Name: string;
}

@Component({
  selector: 'create-quote-template.dialog',
  templateUrl: 'create-quote-template.dialog.html',
  styleUrls: ['./create-quote-template.dialog.scss'],
})
export class QuoteTemplateDialog extends AbstractBiditComponent  {
  
  constructor(deviceDetectorService: DeviceDetectorService,
    private quoteService: QuoteService,
    public dialogRef: MatDialogRef<QuoteTemplateDialog>,
    @Inject(MAT_DIALOG_DATA) public data: TemplateDialogData) {
    super(deviceDetectorService)
  }

  saveTemplate(form: NgForm) {
    this.errors = '';

    if (form.valid) {
      this.isRequesting = true;

      this.quoteService.newQuoteTemplate(this.data.quote_ID, this.data.quoteTemplate_Name)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe(
          {
            next: (result) => {
              if (result) {
                this.dialogRef.close(result);
              }
            },
            error: (error: string) => this.onError(error)
          });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
